import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { ElementType } from "../dom-tools/ElementType";
import { ProceduralText } from "../text/ProceduralText";
import { RegExpUtility } from "../text/RegExpUtility";

export class PathNavigation
{
  static readonly type = new ElementType( "path--navigation" );
  static readonly part = new ElementType( "path--navigation-part" );

  static applyOnDocument()
  {
    PathNavigation.type.forAllInDoc( e => PathNavigation.applyOnElement( e ) ); 
  } 

  static applyOnElement( el:Element )
  {
    let relativeBase = el.textContent;
    el.innerHTML = "";

    let path = window.location.pathname;
    console.log( "path navi", path );

    if ( path.startsWith( relativeBase ) )
    {
      path = path.substring( relativeBase.length );
    }

    path = RegExpUtility.parentPath( path );

    path = path.replace( /^\//, "" );
    path = path.replace( /\/$/, "" );

    let parts = path.split( "/" );

    parts.forEach(
      ( p )=>
      {
        if ( ! p )
        {
          console.log( "null parts:", parts );
          return;
        }

        console.log( "create label" );
        let depth = parts.indexOf( p );
        let labelValue = depth === 0 ? ".." : p; 
        let label = PathNavigation.part.create( labelValue ); 
        console.log( "create anchor", label );
        let anchor = ElementType.anchor.create( label );
        
        let partPath = ProceduralText.repeat( "../", depth );

        ElementAttribute.href.to( anchor, partPath )

        el.appendChild( anchor );
      }
    );


  }
}